import '@inter-ikea-kompis/react/initialize'
import './styles/globals.css'
import '@ingka/variables/_light-mode.css'
import '@ingka/variables/design-tokens-root.css'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { getAppVersion } from '@/utils/get-app-version'

import { ErrorComponent } from './components/error-component'
import { FullscreenSpinner } from './components/fullscreen-spinner'
import { initSentry } from './integrations/sentry'
import { _queryClient } from './integrations/tanstack/query'
import { routeTree } from './route-tree.gen'
import { getBasePathFromUrl } from './utils/base-path-params'
import { SceneHistoryMap } from './utils/scene-history-map'

const style =
  'background: #0158a3; color: #fff; font-weight: 700; border-radius: 5px; padding-inline: 5px; font-size: 1.2em;'
// Logging the app version for informational purposes
// oxlint-disable-next-line eslint/no-console
console.info('%cSofa', style, `Sofa Platform v${getAppVersion()}`)

export const router = createRouter({
  basepath: getBasePathFromUrl(location.pathname),
  context: {
    queryClient: _queryClient,
    sceneHistory: new SceneHistoryMap(),
  },
  defaultErrorComponent: ErrorComponent,
  defaultPendingComponent: () => <FullscreenSpinner show />,
  defaultPreload: 'intent',
  defaultStructuralSharing: true,
  routeTree,
  scrollRestoration: true,
  scrollRestorationBehavior: 'smooth',
  scrollToTopSelectors: ['#sidebar-content'],
})

export type Router = typeof router
initSentry(router)

declare module '@tanstack/react-router' {
  interface HistoryState {
    fromGallery?: boolean
    skipHistory?: boolean
  }
  interface Register {
    router: Router
  }
}

const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={_queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
      <canvas aria-hidden id="scene" tabIndex={-2} />
    </StrictMode>,
  )
}
